'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.attachmentEditorWidget = function (attachmentEditorController) {
	return mmWidgets.each(this, function () {
		const element = this,
			actionElements = element.find('[data-mm-attachment-action]'),
			detailElements = element.find('[data-mm-attachment-detail]'),
			reload = function (attachmentDetails, availableActions) {
				const configureAction = function (item) {
						if (availableActions[item.getAttribute('data-mm-attachment-action')]) {
							item.classList.remove('hidden');
						} else {
							item.classList.add('hidden');
						}
						if (item.getAttribute('data-mm-attachment-action') === 'download') {
							item.setAttribute('download', attachmentDetails.name || 'attachment.html');
						}
					},
					configureDetail = function (item) {
						const detail = attachmentDetails[item.getAttribute('data-mm-attachment-detail')];
						if (!detail) {
							item.classList.add('hidden');
						} else {
							item.classList.remove('hidden');
							if (item.tagName === 'A') {
								item.setAttribute('href', detail);
							} else if (item.tagName === 'IFRAME') {
								item.setAttribute('src', detail);
							} else {
								item.innerHTML = detail;
							}
						}
					};
				detailElements.domElements.forEach(configureDetail);
				actionElements.domElements.forEach(configureAction);
			};
		attachmentEditorController.addEventListener('view', reload);
		element.on('hide', function () {
			attachmentEditorController.cleanup();
			element.find('iframe').attr('src', '');
		});
	});
};
